import { Injectable } from "@angular/core";
import { HttpClient } from '@angular/common/http';
import { UserUpdateRequest } from "./profile/user-update-request";
import { ChangePasswordRequest } from "./change-password/change-password-request";
import { ChangeMobileRequest } from "./change-mobile/change-mobile";
import { ChangeEmailRequest } from "./change-email/change-email";
import { BillHistoryRequest } from "./bill-history/bill-history-request";
import { BillHistoryRequestPassport } from "./bill-history/bill-history-request-passport";
import { AddRegisteredBilerReq } from "./add-registered-biller";

@Injectable()
export class UserService {
    constructor(public http: HttpClient) { }

    updateUser(userrequest: UserUpdateRequest): any {
        const userequest = JSON.stringify(userrequest);
        return this.http.post('/patron/api/account/update', userequest, { observe: 'response' })
    }

    changePassword(changePassReq: ChangePasswordRequest): any {
        const changepass = JSON.stringify(changePassReq);
        return this.http.post('/patron/api/account/password/change', changepass, { observe: 'response' })
    }

    changeMobile(changeMobReq: ChangeMobileRequest): any {
        const changepass = JSON.stringify(changeMobReq);
        return this.http.post('/patron/api/account/mobile/change', changepass, { observe: 'response' })
    }

    changeEmail(changeEmailReq: ChangeEmailRequest): any {
        const changeEmail = JSON.stringify(changeEmailReq);
        return this.http.post('/patron/api/account/email/change', changeEmail, { observe: 'response' })
    }

    getBillHistory(billHistReq: BillHistoryRequest): any {
        const getHistory = JSON.stringify(billHistReq);
        return this.http.post('/patron/access/trans/history', getHistory, { observe: 'response',responseType:'text'})
    }
  getBillHistoryPassport(billHistoryRequestPassport: BillHistoryRequestPassport): any {
    const getHistory = JSON.stringify(billHistoryRequestPassport);
    return this.http.post('/patron/access/trans/history/passport', getHistory, { observe: 'response',responseType:'text'})
  }

    addBiller(addRegiBillReq: AddRegisteredBilerReq): any {
        const addRegiBiller = JSON.stringify(addRegiBillReq);
        return this.http.post('/patron/access/add-registered-biller', addRegiBiller, { observe: 'response'})
    }

    getRegisteredBillers(ekpayid: string): any {
        return this.http.post("/patron/open/get-registered-biller?ekpay_id=" + ekpayid, { observe: 'response' },{responseType: 'text'});
    }

    deleteBiller(reg_id: string): any {
        return this.http.post("/patron/access/del-registered-biller?id=" + reg_id, { observe: 'response' });
    }

    updateBiller(addRegiBillReq: AddRegisteredBilerReq): any {
        const updateRegiBiller = JSON.stringify(addRegiBillReq);
        return this.http.post('/patron/access/upd-registered-biller', updateRegiBiller, { observe: 'response' })
    }

}



// WEBPACK FOOTER //
// ./src/app/user/user.service.ts